<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-if="showGerarNovaCompra && hasRoleComprador"
        @click="onClickGerarCompra"
      >
        <v-list-item-content>Gerar nova compra</v-list-item-content>
      </v-list-item>
      <px-aprovacao-compra-geracao-parcial-dialog v-if="showGerarCompraParcial && hasRoleAprovador"
                                                  :aprovacao-id="aprovacao.id">
        <template v-slot:activator="{ on }">
          <v-list-item
            v-on="on"
          >
            <v-list-item-content>Gerar compra parcial</v-list-item-content>
          </v-list-item>
        </template>
      </px-aprovacao-compra-geracao-parcial-dialog>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import AprovacaoCompraGeracaoParcialDialog
  from '@/modules/aprovacao-compra/components/AprovacaoCompraGeracaoParcialDialog.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
    showGerarNovaCompra: {
      type: Boolean,
      default: false,
    },
    showGerarCompraParcial: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleAprovador', 'hasRoleComprador']),
  },
  methods: {
    onClickGerarCompra() {
      this.$router.push({
        name: 'main.compras.cadastro',
        query: {
          isRascunho: false,
          isCopy: false,
          idAprovacao: this.aprovacao.id,
        },
      });
    },
  },
  components: {
    pxAprovacaoCompraGeracaoParcialDialog: AprovacaoCompraGeracaoParcialDialog,
  },
};
</script>
